export default "__VITE_ASSET__B2tST$R8__"